<template>
  <reports-container></reports-container>
</template>
<script>
import ReportsContainer from "../../apps/positions/reports/ReportsContainer";

export default {
  components: {ReportsContainer}
};
</script>
<style>

</style>
